import React from 'react';
import ArticleLayout, { stripBullet } from '../components/site/ArticleLayout';
import useLang from '../i18n/useLang';
import AINoCode from '../images/AINoCode.webp';

// Sub-headings are stored as "1. Some heading:"; drop the trailing colon when they stand alone.
const asHeading = (text) => stripBullet(text).trim().replace(/:$/, '');

const BlogAI = () => {
  const { t } = useLang();

  return (
    <ArticleLayout
      title={t('blogs.blogNocodeAI.header1')}
      image={AINoCode}
      imageAlt={t('blogs.blogNocodeAI.header1')}
      author={t('blogs.blogMaimPage.Yuval')}
      date="2024-12-05"
    >
      <p>{t('blogs.blogNocodeAI.IntroParagraph')}</p>

      <h2>{t('blogs.blogNocodeAI.header2')}</h2>

      <h3>{asHeading(t('blogs.blogNocodeAI.featureSub'))}</h3>
      <p>{t('blogs.blogNocodeAI.feature1')}</p>
      <ul>
        <li>
          <strong>{stripBullet(t('blogs.blogNocodeAI.feature2BOLD'))}</strong> {t('blogs.blogNocodeAI.feature2')}
        </li>
        <li>
          <strong>{stripBullet(t('blogs.blogNocodeAI.feature3BOLD'))}</strong> {t('blogs.blogNocodeAI.feature3')}
        </li>
      </ul>

      <h3>{asHeading(t('blogs.blogNocodeAI.featureSub2'))}</h3>
      <ul>
        <li>
          <strong>{stripBullet(t('blogs.blogNocodeAI.feature4BOLD'))}</strong> {t('blogs.blogNocodeAI.feature4')}
        </li>
        <li>
          <strong>{stripBullet(t('blogs.blogNocodeAI.feature5BOLD'))}</strong> {t('blogs.blogNocodeAI.feature5')}
        </li>
      </ul>

      <h2>{t('blogs.blogNocodeAI.header3')}</h2>

      <h3>{asHeading(t('blogs.blogNocodeAI.AIsub'))}</h3>
      <p>
        <strong>{stripBullet(t('blogs.blogNocodeAI.AifirstdotBOLD'))}</strong> {t('blogs.blogNocodeAI.Aifirstdot')}
      </p>
      <p>
        <strong>{stripBullet(t('blogs.blogNocodeAI.Aisub2'))}</strong>
      </p>
      <ul>
        <li>
          <strong>{stripBullet(t('blogs.blogNocodeAI.AiSecondDotBOLD'))}</strong> {t('blogs.blogNocodeAI.AiSecondDot')}
        </li>
        <li>
          <strong>{stripBullet(t('blogs.blogNocodeAI.AiThirdDotBOLD'))}</strong> {t('blogs.blogNocodeAI.AiThirdDot')}
        </li>
      </ul>

      <h2>{t('blogs.blogNocodeAI.header4')}</h2>
      <p>{t('blogs.blogNocodeAI.dataModelIntro')}</p>
      <ul>
        <li>
          <strong>{stripBullet(t('blogs.blogNocodeAI.dataModel1BOLD'))}</strong> {t('blogs.blogNocodeAI.dataModel1')}
        </li>
        <li>
          <strong>{stripBullet(t('blogs.blogNocodeAI.dataModel2BOLD'))}</strong> {t('blogs.blogNocodeAI.dataModel2')}
        </li>
        <li>
          <strong>{stripBullet(t('blogs.blogNocodeAI.dataModel3BOLD'))}</strong> {t('blogs.blogNocodeAI.dataModel3')}
        </li>
      </ul>

      <h2>{t('blogs.blogNocodeAI.header5')}</h2>
      <p>{t('blogs.blogNocodeAI.conclusion')}</p>
      <p>
        <strong>{t('blogs.blogNocodeAI.conclusionfeature1BOLD')}</strong> {t('blogs.blogNocodeAI.conclusionfeature1')}
      </p>
      <p>
        <strong>{t('blogs.blogNocodeAI.conclusionfeature2BOLD')}</strong> {t('blogs.blogNocodeAI.conclusionfeature2')}
      </p>
      <p>
        <strong>{t('blogs.blogNocodeAI.conclusionfeature3BOLD')}</strong> {t('blogs.blogNocodeAI.conclusionfeature3')}
      </p>
    </ArticleLayout>
  );
};

export default BlogAI;
